<h2 [innerHTML]="jackpot"></h2>
